import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { initGraphQLClient } from 'app/frontend/javascripts/graphql/index';

function GraphQLProvider({ children }: { children: React.ReactNode }) {
  const client = initGraphQLClient();
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}

export default GraphQLProvider;
